// import React, { useState, useEffect, useRef } from "react";
// import {
//   MapContainer,
//   TileLayer,
//   Polyline,
//   Marker,
//   useMap,
//   Popup,
// } from "react-leaflet";
// import MarkerClusterGroup from "@changey/react-leaflet-markercluster";
// import L from "leaflet";
// import { useDispatch, useSelector } from "react-redux";
// import "../index.css";
// import "leaflet/dist/leaflet.css";
// import "react-leaflet-markercluster/dist/styles.min.css";
// import SvgImage from "../../Icons/Icons";

// const svgIconUrl = encodeURIComponent(
//   `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="#e57231" d="M384 192c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192z"/></svg>`
// );
// const svgIconUrl2 = encodeURIComponent(
//   `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#485b7c" d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/></svg>`
// );

// const customIcon = new L.Icon({
//   iconUrl: require("../../../assets/images/truck-32.png"), // Adjust the path as needed
//   // iconUrl: require("../../../assets/images/truck-32.png"), // Adjust the path as needed
//   iconSize: [35, 35], // Size of the icon
//   iconAnchor: [17, 35], // Point of the icon which will correspond to marker's location
//   popupAnchor: [0, -35], // Point from which the popup should open relative to the iconAnchor
// });

// const createRotatedIcon = (bearing, flip) => {
//   return new L.divIcon({
//     iconUrl: require("../../../assets/images/truck-32.png"), // Adjust the path as needed
//     // html: `<img src=${require("../../../assets/images/truck-32.png")} style="transform: rotate(${bearing}deg) ${flip ? 'scaleX(-1)' : ''} background: none;"/>`,
//     // // iconUrl: require("../../../assets/images/truck-32.png"), // Adjust the path as needed
//     html: `<div style="transform: rotate(${bearing}deg) ${
//       flip ? "scaleY(-1)" : ""
//     }; background: none; border: none;">
//     <img src=${require("../../../assets/images/truck-32.png")} style="width: 30px; height: 30px;"/>
//   </div>`,
//     className: "leaflet-icon",
//     iconSize: [35, 35], // Size of the icon
//     iconAnchor: [17, 35], // Point of the icon which will correspond to marker's location
//     popupAnchor: [0, -35], // Point from which the popup should open relative to the iconAnchor
//   });
// };

// const customIcon2 = new L.Icon({
//   iconUrl: `data:image/svg+xml,${svgIconUrl2}`,
//   // iconUrl: require("../../../assets/images/truck-32.png"), // Adjust the path as needed
//   iconSize: [15, 15], // Size of the icon
//   iconAnchor: [8, 10], // Point of the icon which will correspond to marker's location
//   popupAnchor: [0, -35], // Point from which the popup should open relative to the iconAnchor
// });

// // const FitBounds = ({ bounds }) => {
// //   const map = useMap();

// //   useEffect(() => {
// //     if (bounds) {
// //       map.fitBounds(bounds);
// //     }
// //   }, [map, bounds]);

// //   return null;
// // };
// const radians = (degrees) => (degrees * Math.PI) / 180;

// // Converts radians to degrees
// const degrees = (radians) => (radians * 180) / Math.PI;

// // Calculate bearing between two points
// // const calculateBearing = (start, end) => {
// //   const startLat = radians(start[0]);
// //   const startLng = radians(start[1]);
// //   const endLat = radians(end[0]);
// //   const endLng = radians(end[1]);

// //   const dLong = endLng - startLng;
// //   const dPhi = Math.log(Math.tan(endLat / 2.0 + Math.PI / 4.0) / Math.tan(startLat / 2.0 + Math.PI / 4.0));

// //   if (Math.abs(dLong) > Math.PI) {
// //     if (dLong > 0) {
// //       dLong = -(2 * Math.PI - dLong);
// //     } else {
// //       dLong = (2 * Math.PI + dLong);
// //     }
// //   }
// //   console.log("miejrigjnier",((degrees(Math.atan2(dLong, dPhi)) + 360) % 360),start,end)

// //   return (degrees(Math.atan2(dLong, dPhi)) + 360) % 360;
// // };

// function degreesToRadians(degrees) {
//   return (degrees * Math.PI) / 180;
// }

// function calculateBearing(start, end) {
//   const lat1 = radians(start[0]);
//   const lon1 = radians(start[1]);
//   const lat2 = radians(end[0]);
//   const lon2 = radians(end[1]);
//   const phi1 = degreesToRadians(lat1);
//   const phi2 = degreesToRadians(lat2);
//   const deltaLambda = degreesToRadians(lon2 - lon1);

//   const y = Math.sin(deltaLambda) * Math.cos(phi2);
//   const x =
//     Math.cos(phi1) * Math.sin(phi2) -
//     Math.sin(phi1) * Math.cos(phi2) * Math.cos(deltaLambda);
//   const theta = Math.atan2(y, x);
//   console.log(
//     "miejrigjnier",
//     ((theta * 180) / Math.PI + 360) % 360,
//     start,
//     end
//   );

//   return ((theta * 180) / Math.PI + 360) % 360; // Convert bearing to degrees and normalize
// }

// const MapV2 = (props) => {
//   const { path, setPath, selection, openStatus, mark, setMarker } = props;
//   //   const [path, setPath] = useState([[props.latt, props.longg]]);
//   console.log("jkkkklllllll", props, path);
//   const { gpsStatus, gpsData } = useSelector((state) => state?.fleet);
//   const mapRef = useRef(null);
//   const ZoomToNewRoute = ({ position }) => {
//     const map = useMap();
//     useEffect(() => {
//       console.log(
//         "comiinggeree",
//         path,
//         position == "0",
//         mapRef.current,
//         gpsData?.data.length > 0
//       );
//       if (position == "0") {
//         if (mapRef.current && gpsData?.data.length > 0) {
//           const bounds = gpsData?.data?.map(({ latitude, longitude }) => [
//             latitude,
//             longitude,
//           ]);
//           mapRef.current.fitBounds(bounds);
//         }
//       } else if (position) {
//         map.flyTo(position, 13, { duration: 1 });
//       }
//     }, [position, map, path]);

//     return null;
//   };
//   console.log("eachDataaa", gpsData);

//   const ZoomToRoute = ({ route }) => {
//     const map = useMap();

//     useEffect(() => {
//       if (route?.length > 0) {
//         console.log("eacrrehDataaa",route,path);
//         const bounds = L.latLngBounds(route);
//         map.fitBounds(bounds);
//       }
//     }, [map, route]);

//     return null;
//   };

//   // const [selection, setSelection] = useState(false);
//   // Simulate live data updates
//   console.log(
//     "gpsmapDatattaaa----",
//     gpsData,
//     path,
//     selection,
//     path?.length > 0 && !selection
//   );

//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [isPlaying, setIsPlaying] = useState(false);
//   const [speed, setSpeed] = useState(1000); // Playback speed in milliseconds
//   const intervalRef = useRef(null);

//   // Example coordinates (latitude, longitude)
//   const startPlayback = () => {
//     setIsPlaying(true);
//     setCurrentIndex(0);
//   };

//   const pausePlayback = () => {
//     setIsPlaying(false);
//   };

//   const stopPlayback = () => {
//     setIsPlaying(false);
//     setCurrentIndex(0);
//   };

//   const changeSpeed = (newSpeed) => {
//     setSpeed(newSpeed);
//   };
//   //Point zoom in
//   const UpdateMapBounds = ({ position }) => {
//     const map = useMap();

//     useEffect(() => {
//       console.log("knnienrio", map.getZoom());
//       if (position) {
//         map.setView(position, 5);
//         map.fitBounds(L.latLngBounds([position]));
//       }
//     }, [map, position]);

//     return null;
//   };

//   let rotatedIcon;

//   useEffect(() => {
//     setCurrentIndex(0);
//     setMarker(path?.[0] || [20.5937, 78.9629]);
//     rotatedIcon = createRotatedIcon(0);
//     console.log("njniodhf", rotatedIcon);
//   }, [openStatus]);

//   useEffect(() => {
//     if (path?.length > 0) {
//       let currentPosition = path[currentIndex];
//       let nextPosition = path[currentIndex + 1]
//         ? path[currentIndex + 1]
//         : path[currentIndex];
//       let bearing;
//       if (currentPosition == nextPosition) {
//         currentPosition = path[currentIndex - 1]
//           ? path[currentIndex - 1]
//           : path[currentIndex];
//         bearing = calculateBearing(currentPosition, nextPosition);
//       } else 
//       bearing = calculateBearing(currentPosition, nextPosition);
//       bearing = bearing - 90;
//       let flip =
//         bearing == "0" ? false : bearing > 90 && bearing < 270 ? true : false;
//       console.log("ijijweijfie", path[0], nextPosition, currentIndex, bearing);
//       rotatedIcon = createRotatedIcon(bearing, flip);
//     }
//   }, [mark]);

//   useEffect(() => {
//     console.log("njnihihs", mark);
//     if (isPlaying) {
//       intervalRef.current = setInterval(() => {
//         setCurrentIndex((prevIndex) => {
//           const nextIndex = prevIndex + 1;
//           if (nextIndex >= path.length) {
//             clearInterval(intervalRef.current);
//             setIsPlaying(false);
//             setCurrentIndex(0);
//             return prevIndex;
//           }
//           setMarker(path[nextIndex]);
//           // const currentPosition = path[currentIndex];
//           // const nextPosition = path[currentIndex + 1] ? path[currentIndex + 1] : path[currentIndex];
//           // console.log("njheruihg",currentPosition,nextPosition)
//           // const bearing1 = calculateBearing(currentPosition, nextPosition);

//           // setBearing(bearing1);
//           return nextIndex;
//         });
//       }, speed);
//     } else if (!isPlaying && intervalRef.current) {
//       clearInterval(intervalRef.current);
//     }

//     return () => clearInterval(intervalRef.current);
//   }, [isPlaying, speed, path.length]);
//   if (path?.length > 0) {
//     const currentPosition = path[currentIndex];
//     const nextPosition = path[currentIndex + 1]
//       ? path[currentIndex + 1]
//       : path[currentIndex];
//     let bearing = calculateBearing(currentPosition, nextPosition);
//     bearing = bearing - 90;
//     let flip =
//       bearing == "0" ? false : bearing > 90 && bearing < 270 ? true : false;
//     console.log("ijijweijfie", path[0], nextPosition, currentIndex, bearing);
//     rotatedIcon = createRotatedIcon(bearing, flip);
//   }

//   const progress =
//     (currentIndex / (path.length - 1)) * 100 == 100
//       ? 0
//       : (currentIndex / (path.length - 1)) * 100;
//   // const PolylineDecoratorComponent = ({ route }) => {
//   //   usePolylineDecorator(route);
//   //   return null;
//   // };
//   return (
//     <div className="map-container">
//       <div>
//         <MapContainer
//           center={
//             path?.length > 0 && (selection == "1" || selection == "2")
//               ? [props.latt, props.longg]
//               : [20.5937, 78.9629]
//           }
//           zoom={5}
//           style={{ height: "70vh", width: "100%" }}
//           scrollWheelZoom={true}
//           ref={mapRef}
//         >
//           <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

//           {/* Marker for the latest position */}
//           {path?.length > 0 && selection == "2" ? (
//             <>
//               {/* <ZoomToNewRoute position={mark || path[0]} /> */}
//               <Marker
//                 position={mark || path[path?.length - 1]}
//                 icon={rotatedIcon}
//               />
//               <Polyline positions={path} color="blue" />{" "}
//               {/* <FitBounds bounds={bounds} /> */}
//               {path.map((coord, index) => (
//                 <Marker position={coord} index={index} icon={customIcon2} />
//               ))}
//               <ZoomToRoute route={path} />
//               {/* <UpdateMapBounds position={mark} /> */}
//             </>
//           ) : path?.length > 0 && selection == "1" ? (
//             <>
//               <ZoomToNewRoute position={path[0]} />
//               <Marker position={path[path?.length - 1]} icon={customIcon} />
//               <Polyline positions={path} color="green" />{" "}
//             </>
//           ) : (
//             <MarkerClusterGroup>
//               {gpsData?.data?.map((data, index) => {
//                 console.log("eachDataaa", data);
//                 return (
//                   <>
//                     <ZoomToNewRoute position={"0"} />
//                     <Marker
//                       position={[data?.latitude, data?.longitude]}
//                       zoom={6}
//                       icon={customIcon}
//                       key={index}
//                     >
//                       <Popup>{data?.vrn}</Popup>
//                     </Marker>
//                   </>
//                 );
//               })}
//             </MarkerClusterGroup>
//           )}
//         </MapContainer>
//         {selection == "2" ? (
//           <div style={{height:"30vh"}}>
//             <div style={{ textAlign: "center" }}>
//               <div style={{ width: "100%", backgroundColor: "#ddd" }}>
//                 <div className="d-flex">
//                   <div
//                     style={{
//                       height: "20px",
//                       backgroundColor: "#4CAF50",
//                       width: `${progress}%`,
//                       textAlign: "end",
//                     }}
//                   >
//                     <div style={{ margin: "-3px -13px 0 0px" }}>
//                       <SvgImage name="circleLogo" />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div
//               className="row"
//               style={{
//                 padding: "30px 0 0 0",
//               }}
//             >
//               <div className="col-6 d-flex justify-content-end">
//                 <div
//                   style={{
//                     border: "0.5px solid rgb(226, 226, 226)",
//                     borderRadius: "0.5rem",
//                     width: "35px",
//                     height: "35px",
//                     textAlign: "center",
//                     padding: "4px 0 0 0",
//                     cursor: "pointer",
//                     backgroundColor: !isPlaying ? "bisque" : "#ffffff",
//                   }}
//                   onClick={pausePlayback}
//                 >
//                   <SvgImage name="pauseButton" />
//                 </div>
//                 <div
//                   style={{
//                     border: "0.5px solid rgb(226, 226, 226)",
//                     borderRadius: "0.5rem",
//                     width: "35px",
//                     height: "35px",
//                     margin: "0 0px 0 10px",
//                     textAlign: "center",
//                     padding: "4px 0 0 0",
//                     cursor: "pointer",
//                     backgroundColor: isPlaying ? "bisque" : "#ffffff",
//                   }}
//                   onClick={startPlayback}
//                 >
//                   <SvgImage name="playButton" />
//                 </div>
//                 {/* <button onClick={startPlayback} disabled={isPlaying}>
//             Play
//           </button>
//           <button onClick={pausePlayback} disabled={!isPlaying}>
//             Pause
//           </button>
//           <button onClick={stopPlayback}>Stop</button> */}
//                 {/* <div style={{ marginTop: "10px" }}>
//             <button onClick={() => changeSpeed(5000)} disabled={speed === 5000}>
//               Slow
//             </button>
//             <button onClick={() => changeSpeed(1000)} disabled={speed === 1000}>
//               Normal
//             </button>
//             <button onClick={() => changeSpeed(500)} disabled={speed === 500}>
//               Fast
//             </button>
//           </div> */}
//               </div>
//               <div
//                 className="col-6 d-flex justify-content-end"
//                 // onClick={startPlayback}
//               >
//                 <div style={{ padding: "8px 0 0 0" }} className="FontNS16">
//                   Play Speed
//                 </div>
//                 <div
//                   style={{
//                     border: "0.5px solid rgb(226, 226, 226)",
//                     borderRadius: "0.5rem",
//                     width: "40px",
//                     height: "40px",
//                     margin: "0 0px 0 10px",
//                     textAlign: "center",
//                     padding: "8px 0 0 0",
//                     cursor: "pointer",
//                     backgroundColor: speed == "5000" ? "bisque" : "#ffffff",
//                   }}
//                   className="FontNS14"
//                   onClick={() => changeSpeed(5000)}
//                 >
//                   0.5X
//                 </div>{" "}
//                 <div
//                   style={{
//                     border: "0.5px solid rgb(226, 226, 226)",
//                     borderRadius: "0.5rem",
//                     width: "40px",
//                     height: "40px",
//                     margin: "0 0px 0 10px",
//                     textAlign: "center",
//                     padding: "8px 0 0 0",
//                     cursor: "pointer",
//                     backgroundColor: speed == "1000" ? "bisque" : "#ffffff",
//                   }}
//                   className="FontNS14"
//                   onClick={() => changeSpeed(1000)}
//                   // onClick={startPlayback}
//                 >
//                   1X
//                 </div>{" "}
//                 <div
//                   style={{
//                     border: "0.5px solid rgb(226, 226, 226)",
//                     borderRadius: "0.5rem",
//                     width: "40px",
//                     height: "40px",
//                     margin: "0 0px 0 10px",
//                     textAlign: "center",
//                     padding: "8px 0 0 0",
//                     cursor: "pointer",
//                     backgroundColor: speed == "500" ? "bisque" : "#ffffff",
//                   }}
//                   className="FontNS14"
//                   onClick={() => changeSpeed(500)}
//                   // onClick={startPlayback}
//                 >
//                   2X
//                 </div>
//               </div>
//             </div>
//           </div>
//         ) : (
//           <div style={{height:"30vh"}}></div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default MapV2;



import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  MapContainer,
  TileLayer,
  Polyline,
  Marker,
  useMap,
  Popup,
} from "react-leaflet";
import MarkerClusterGroup from "@changey/react-leaflet-markercluster";
import L from "leaflet";
import { useDispatch, useSelector } from "react-redux";
import "../index.css";
import "leaflet/dist/leaflet.css";
import "react-leaflet-markercluster/dist/styles.min.css";
import "leaflet-routing-machine/dist/leaflet-routing-machine.css";
import "leaflet-routing-machine";

import SvgImage from "../../Icons/Icons";
import Info from "./info";

const svgIconUrl = encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="#e57231" d="M384 192c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192z"/></svg>`
);
const svgIconUrl2 = encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#485b7c" d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/></svg>`
);

const svgIconUrl3 = encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="#e57231" d="M384 192c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192z"/></svg>`)

const customIcon = (vrn) => {
  return new L.divIcon({
  className: "vrn-icon",
  // iconUrl: require("../../../assets/images/truck-32.png"), // Adjust the path as needed
  // iconUrl: require("../../../assets/images/truck-32.png"), // Adjust the path as needed
  iconSize: [35, 35], // Size of the icon
  iconAnchor: [17, 35], // Point of the icon which will correspond to marker's location
  popupAnchor: [0, -35], // Point from which the popup should open relative to the iconAnchor
  html: `<div><div class="vrn-icon-text">${vrn?vrn.slice(-4): ""}</div></div>   `  
})};

const createRotatedIcon = (bearing, flip) => {
  return new L.divIcon({
    iconUrl: require("../../../assets/images/truck-32.png"), // Adjust the path as needed
    // html: `<img src=${require("../../../assets/images/truck-32.png")} style="transform: rotate(${bearing}deg) ${flip ? 'scaleX(-1)' : ''} background: none;"/>`,
    // // iconUrl: require("../../../assets/images/truck-32.png"), // Adjust the path as needed
    html: `<div style="transform: rotate(${bearing}deg) ${
      flip ? "scaleY(-1)" : ""
    }; background: none; border: none;">
    <img src=${require("../../../assets/images/truck-32.png")} style="width: 30px; height: 30px;"/>
  </div>`,
    className: "leaflet-icon",
    iconSize: [35, 35], // Size of the icon
    iconAnchor: [17, 35], // Point of the icon which will correspond to marker's location
    popupAnchor: [0, -35], // Point from which the popup should open relative to the iconAnchor
  });
};

const customIcon2 = new L.Icon({
  iconUrl: `data:image/svg+xml,${svgIconUrl2}`,
  // iconUrl: require("../../../assets/images/truck-32.png"), // Adjust the path as needed
  iconSize: [15, 15], // Size of the icon
  iconAnchor: [8, 10], // Point of the icon which will correspond to marker's location
  popupAnchor: [0, -35], // Point from which the popup should open relative to the iconAnchor
});

const customIcon3 = new L.Icon({
  iconUrl: `data:image/svg+xml,${svgIconUrl3}`,
  // iconUrl: require("../../../assets/images/truck-32.png"), // Adjust the path as needed
  iconSize: [30, 30], // Size of the icon
  iconAnchor: [12, 31], // Point of the icon which will correspond to marker's location
  popupAnchor: [0, -35], // Point from which the popup should open relative to the iconAnchor
});

const radians = (degrees) => (degrees * Math.PI) / 180;
function degreesToRadians(degrees) {
  return (degrees * Math.PI) / 180;
}

function calculateBearing(start, end) {
  const lat1 = radians(start[0]);
  const lon1 = radians(start[1]);
  const lat2 = radians(end[0]);
  const lon2 = radians(end[1]);
  const phi1 = degreesToRadians(lat1);
  const phi2 = degreesToRadians(lat2);
  const deltaLambda = degreesToRadians(lon2 - lon1);

  const y = Math.sin(deltaLambda) * Math.cos(phi2);
  const x =
    Math.cos(phi1) * Math.sin(phi2) -
    Math.sin(phi1) * Math.cos(phi2) * Math.cos(deltaLambda);
  const theta = Math.atan2(y, x);
  console.log(
    "miejrigjnier",
    ((theta * 180) / Math.PI + 360) % 360,
    start,
    end
  );

  return ((theta * 180) / Math.PI + 360) % 360; // Convert bearing to degrees and normalize
}

const MapV2 = (props) => {
  const { path, setPath, selection, openStatus, mark, setMarker } = props;
  //   const [path, setPath] = useState([[props.latt, props.longg]]);
  console.log("jkkkklllllll", props, path,selection,(path?.length > 0 && path[0]?.length > 0));
  const { gpsStatus, gpsData } = useSelector((state) => state?.fleet);
  const mapRef = useRef(null);
  const ZoomToNewRoute = ({ position }) => {
    console.log("njneiofhgioher",position)
    useEffect(() => {
      if(!mapRef?.current) return;
      if (mapRef?.current && position?.length>0 && position[0]) {
        mapRef?.current.flyTo(position, 13);
      }
      return () => {
        if( mapRef?.current){
          mapRef?.current?.flyTo([20.5937, 78.9629],5);
        }
        // This will be called when the component is unmounted
        // Alternatively, if you want to completely remove the map:
        // map.remove();
      };
    }, [position]);

    return null;
  };
  console.log("eachDataaa", gpsData);

  const ZoomToRoute = ({ route }) => {
    const map = useMap();

    useEffect(() => {
      if (route?.length > 0) {
        console.log("eacrrehDataaa",route,path);
        const bounds = L.latLngBounds(route);
        map.fitBounds(bounds);
      }
    }, [map, route]);

    return null;
  };


    useEffect(() => {
      console.log("njnerihire")
      if (!mapRef.current) return;
      if(path?.length > 0){
        const waypoints = path.map(coord => L.latLng(coord[0], coord[1]));
  
        routeControlRef.current = L.Routing.control({
          waypoints: waypoints,
          lineOptions: {
            styles: [{ color: "#6FA1EC", weight: 4 }]
          },
          show: false,
          createMarker: function() {
            return null; // Return null to prevent default markers
          },
          routeWhileDragging: true
        }).addTo(mapRef.current);
    
        // map.fitBounds(L.latLngBounds(waypoints));   
      }
          
      return () => {
        console.log("njnerihire",routeControlRef.current,path)
        if (routeControlRef?.current && mapRef?.current) {
          mapRef.current.removeControl(routeControlRef.current);
        }
      };   
  }, [path]);


  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [speed, setSpeed] = useState(1000); // Playback speed in milliseconds
  const intervalRef = useRef(null);

  // Example coordinates (latitude, longitude)
  const startPlayback = () => {
    setIsPlaying(true);
    setCurrentIndex(0);
  };

  const pausePlayback = () => {
    setIsPlaying(false);
  };

  const stopPlayback = () => {
    setIsPlaying(false);
    setCurrentIndex(0);
  };

  const changeSpeed = (newSpeed) => {
    setSpeed(newSpeed);
  };
  //Point zoom in
  const UpdateMapBounds = ({ position }) => {
    const map = useMap();

    useEffect(() => {
      console.log("knnienrio", map.getZoom());
      if (position) {
        map.setView(position, 5);
        map.fitBounds(L.latLngBounds([position]));
      }
    }, [map, position]);

    return null;
  };

  let rotatedIcon;
  let routeControlRef = useRef(null);

  useEffect(() => {
    setCurrentIndex(0);
    setMarker(path?.[path?.length-1] || [20.5937, 78.9629]);
    rotatedIcon = createRotatedIcon(0);
    console.log("njniodhf", rotatedIcon);
    
  }, [openStatus,path]);

  useEffect(() => {
    if (path?.length > 0) {
      let currentPosition = path[currentIndex];
      let nextPosition = path[currentIndex + 1]
        ? path[currentIndex + 1]
        : path[currentIndex];
      let bearing;
      if (currentPosition == nextPosition) {
        currentPosition = path[currentIndex - 1]
          ? path[currentIndex - 1]
          : path[currentIndex];
        bearing = calculateBearing(currentPosition, nextPosition);
      } else 
      bearing = calculateBearing(currentPosition, nextPosition);
      bearing = bearing - 90;
      let flip =
        bearing == "0" ? false : bearing > 90 && bearing < 270 ? true : false;
      console.log("ijijweijfie", path[0], nextPosition, currentIndex, bearing);
      rotatedIcon = createRotatedIcon(bearing, flip);
    }
  }, [mark]);

  useEffect(() => {
    console.log("njnihihs", mark);
    if (isPlaying && routeControlRef?.current) {
      intervalRef.current = setInterval(() => {
        setCurrentIndex((prevIndex) => {
          const nextIndex = prevIndex + 1;
          if (nextIndex >= path.length) {
            clearInterval(intervalRef.current);
            setIsPlaying(false);
            setCurrentIndex(0);
            return prevIndex;
          }
          setMarker(path[nextIndex]);
          // const currentPosition = path[currentIndex];
          // const nextPosition = path[currentIndex + 1] ? path[currentIndex + 1] : path[currentIndex];
          // console.log("njheruihg",currentPosition,nextPosition)
          // const bearing1 = calculateBearing(currentPosition, nextPosition);

          // setBearing(bearing1);
          return nextIndex;
        });
      }, speed);
    } else if (!isPlaying && intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    return () => clearInterval(intervalRef.current);
  }, [isPlaying, speed, path.length]);
  
  if (path?.length > 0) {
    const currentPosition = path[currentIndex];
    const nextPosition = path[currentIndex + 1]
      ? path[currentIndex + 1]
      : path[currentIndex];
    let bearing = calculateBearing(currentPosition, nextPosition);
    bearing = bearing - 90;
    let flip =
      bearing == "0" ? false : bearing > 90 && bearing < 270 ? true : false;
    console.log("ijijweijfie", path[0], nextPosition, currentIndex, bearing);
    rotatedIcon = createRotatedIcon(bearing, flip);
  }



  const progress =
    (currentIndex / (path.length - 1)) * 100 == 100
      ? 0
      : (currentIndex / (path.length - 1)) * 100;


  // const PolylineDecoratorComponent = ({ route }) => {
  //   usePolylineDecorator(route);
  //   return null;
  // };
  return (
    <div className="map-container">
      <div>
        <MapContainer
          center={
            path?.length > 0 && (path[0]?.length > 0) && (selection == "1" || selection == "2")
              ? [props.latt, props.longg]
              : [20.5937, 78.9629]
          }
          zoom={5}
          style={{ height: "70vh", width: "100%" }}
          scrollWheelZoom={true}
          ref={mapRef}
          whenCreated={(mapInstance) => {
            mapRef.current = mapInstance;
          }}
        >
     <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
      />
          {/* Marker for the latest position */}
          {(path?.length > 0 && path[0]?.length > 0) && selection == "2" ? (
            <>
              {/* <ZoomToNewRoute position={mark || path[0]} /> */}
              <Marker
                position={mark || path[path?.length - 1]}
                icon={rotatedIcon}
              />
              {/* <Polyline positions={path} color="blue" />{" "} */}
              {/* <FitBounds bounds={bounds} /> */}
              {/* <RoutingControl path={path}/> */}
              {path.map((coord, index) => (
                <>
                <Marker position={coord} index={index} icon={customIcon2} />
                </>
              ))}
              <ZoomToRoute route={path} />
              {/* <UpdateMapBounds position={mark} /> */}
            </>
          ) : (path?.length > 0 && path[0]?.length > 0) && selection == "3" ? (
            <>
              {/* <ZoomToNewRoute position={mark || path[0]} /> */}
              <Marker
                position={mark || path[path?.length - 1]}
                icon={rotatedIcon}
              />
              {/* <Polyline positions={path} color="blue" />{" "} */}
              {/* <FitBounds bounds={bounds} /> */}
              {/* <RoutingControl path={path}/> */}
              {path.map((coord, index) => (
                <>
                <Marker position={coord} index={index} icon={customIcon2} />
                </>
              ))}
              <Marker
                position={path?.[0] || [20.5937, 78.9629]}
                icon={customIcon3}
              />
              <ZoomToRoute route={path} />
              {/* <UpdateMapBounds position={mark} /> */}
            </>
          ) : (path?.length > 0 && path[0]?.length > 0)&& selection == "1" && props?.latt && props?.longg ? (
            <>
                <ZoomToNewRoute position={[props?.latt, props?.longg]} />
                <Marker position={[props?.latt, props?.longg]} icon={customIcon(props.fleetId)} />
              {/* <Polyline positions={path} color="green" />{" "} */}
            </>
          ) : (
            <MarkerClusterGroup>
              {gpsData?.data?.map((data, index) => {
                console.log("eachDataaa", data);
                return (
                  <>
                  <Marker
                      position={[data?.latitude, data?.longitude]}
                      zoom={6}
                      icon={customIcon(data?.vrn)}
                      key={index}
                    >
                      <Popup>{data?.vrn}</Popup>
                    </Marker>
                  </>
                );
              })}
            </MarkerClusterGroup>
          )}
        </MapContainer>
        {selection == "2" ? (
          <div style={{height:"30vh"}}>
            <div style={{ textAlign: "center" }}>
              <div style={{ width: "100%", backgroundColor: "#ddd" }}>
                <div className="d-flex">
                  <div
                    style={{
                      height: "20px",
                      backgroundColor: "#4CAF50",
                      width: `${progress}%`,
                      textAlign: "end",
                    }}
                  >
                    <div style={{ margin: "-3px -13px 0 0px" }}>
                      <SvgImage name="circleLogo" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row"
              style={{
                padding: "30px 0 0 0",
              }}
            >
              <div className="col-6 d-flex justify-content-end">
                <div
                  style={{
                    border: "0.5px solid rgb(226, 226, 226)",
                    borderRadius: "0.5rem",
                    width: "35px",
                    height: "35px",
                    textAlign: "center",
                    padding: "4px 0 0 0",
                    cursor: "pointer",
                    backgroundColor: !isPlaying ? "bisque" : "#ffffff",
                  }}
                  onClick={pausePlayback}
                >
                  <SvgImage name="pauseButton" />
                </div>
                <div
                  style={{
                    border: "0.5px solid rgb(226, 226, 226)",
                    borderRadius: "0.5rem",
                    width: "35px",
                    height: "35px",
                    margin: "0 0px 0 10px",
                    textAlign: "center",
                    padding: "4px 0 0 0",
                    cursor: "pointer",
                    backgroundColor: isPlaying ? "bisque" : "#ffffff",
                  }}
                  onClick={startPlayback}
                >
                  <SvgImage name="playButton" />
                </div>
                {/* <button onClick={startPlayback} disabled={isPlaying}>
            Play
          </button>
          <button onClick={pausePlayback} disabled={!isPlaying}>
            Pause
          </button>
          <button onClick={stopPlayback}>Stop</button> */}
                {/* <div style={{ marginTop: "10px" }}>
            <button onClick={() => changeSpeed(5000)} disabled={speed === 5000}>
              Slow
            </button>
            <button onClick={() => changeSpeed(1000)} disabled={speed === 1000}>
              Normal
            </button>
            <button onClick={() => changeSpeed(500)} disabled={speed === 500}>
              Fast
            </button>
          </div> */}
              </div>
              <div
                className="col-6 d-flex justify-content-end"
                // onClick={startPlayback}
              >
                <div style={{ padding: "8px 0 0 0" }} className="FontNS16">
                  Play Speed
                </div>
                <div
                  style={{
                    border: "0.5px solid rgb(226, 226, 226)",
                    borderRadius: "0.5rem",
                    width: "40px",
                    height: "40px",
                    margin: "0 0px 0 10px",
                    textAlign: "center",
                    padding: "8px 0 0 0",
                    cursor: "pointer",
                    backgroundColor: speed == "5000" ? "bisque" : "#ffffff",
                  }}
                  className="FontNS14"
                  onClick={() => changeSpeed(5000)}
                >
                  0.5X
                </div>{" "}
                <div
                  style={{
                    border: "0.5px solid rgb(226, 226, 226)",
                    borderRadius: "0.5rem",
                    width: "40px",
                    height: "40px",
                    margin: "0 0px 0 10px",
                    textAlign: "center",
                    padding: "8px 0 0 0",
                    cursor: "pointer",
                    backgroundColor: speed == "1000" ? "bisque" : "#ffffff",
                  }}
                  className="FontNS14"
                  onClick={() => changeSpeed(1000)}
                  // onClick={startPlayback}
                >
                  1X
                </div>{" "}
                <div
                  style={{
                    border: "0.5px solid rgb(226, 226, 226)",
                    borderRadius: "0.5rem",
                    width: "40px",
                    height: "40px",
                    margin: "0 0px 0 10px",
                    textAlign: "center",
                    padding: "8px 0 0 0",
                    cursor: "pointer",
                    backgroundColor: speed == "500" ? "bisque" : "#ffffff",
                  }}
                  className="FontNS14"
                  onClick={() => changeSpeed(500)}
                  // onClick={startPlayback}
                >
                  2X
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div style={{height:"30vh"}}>
            {selection == "1" ? <><Info/>
            </> : <></>}
          </div>
        )}
      </div>
    </div>
  );
};

export default MapV2;
